import { ResetPasswordDto } from '../model/ResetPasswordDto';
export class ResetPasswordDtoResponse{
     public  message:string;
     public  viewName:string;
     public  resetPasswordDto :ResetPasswordDto;
    public outputParam :Map<String,Object>;

}